import { Icon } from '@chakra-ui/react';

export default function SFHorizontalDecreaseIcon(props) {
  return (
    <Icon
      w={6}
      h='14px'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      viewBox='0 0 24 14'
      {...props}
    >
      <g>
        <rect
          height='13.9805'
          opacity='0'
          width='24.0586'
          x='0'
          y='0'
        />
        <path d='M5.8125 13.957L17.9531 13.957C18.4805 13.957 18.9023 13.5469 18.9023 13.0195C18.9023 12.4922 18.4805 12.0703 17.9531 12.0703L5.8125 12.0703C5.28516 12.0703 4.875 12.4922 4.875 13.0195C4.875 13.5469 5.28516 13.957 5.8125 13.957Z' />
        <path d='M3.41016 7.92188L20.3672 7.92188C20.8945 7.92188 21.3047 7.51172 21.3047 6.98438C21.3047 6.45703 20.8945 6.03516 20.3672 6.03516L3.41016 6.03516C2.88281 6.03516 2.46094 6.45703 2.46094 6.98438C2.46094 7.51172 2.88281 7.92188 3.41016 7.92188Z' />
        <path d='M0.9375 1.88672L22.7695 1.88672C23.2969 1.88672 23.707 1.47656 23.707 0.949219C23.707 0.421875 23.2969 0 22.7695 0L0.9375 0C0.410156 0 0 0.421875 0 0.949219C0 1.47656 0.410156 1.88672 0.9375 1.88672Z' />
      </g>
    </Icon>
  );
}
